export enum ValidationState {
  INIT,
  PENDING,
  VALID,
  INVALID,
  REDIRECT,
}
